import { CONFIG_LOAD_SUCCESS, CONFIG_LOAD_FAILURE } from '../constants/ActionTypes';

const initialConfigState = {
  googleApiKey: '',
  tAntenne: [],
  error: null
};

export default (state = initialConfigState, { type, payload }) => {
  switch (type) {
    case CONFIG_LOAD_SUCCESS: {
      return {
        ...state,
        googleApiKey: payload.googleApiKey,
        tAntenne: payload.tAntenne,
        error: null
      };
    }
    case CONFIG_LOAD_FAILURE: {
      return { ...state, error: payload };
    }
    default:
      return state;
  }
};
